import { Box, Tabs, Tab, useTheme } from "@mui/material";
import { CustomTabsType, CustomTabsProps} from "./types";
import { useMemo } from "react";
import { getStyles } from "./utils";

const CustomTabs = <T extends CustomTabsType>({ value, onChange, options, type, centered = false, children, tabsSx = null, wrapperSx = null }: CustomTabsProps<T>) => {
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme, type), [theme, type]);

  return (
    <Box
      sx={wrapperSx}
    >
      <Tabs
        centered={centered}
        variant="scrollable"
        scrollButtons={false}
        value={value} 
        onChange={(_, newValue) => onChange(newValue)}
        sx={{
          ...tabsSx,
          ...styles
        }}
      >
        {options.map((opt, index) => (
          <Tab key={index} disableRipple iconPosition="start" {...opt} />
        ))}
      </Tabs>
      {children}
    </Box>
  );
};

export default CustomTabs;